import {Component, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'slideCount-component',
    templateUrl: 'slideCount.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlideCountComponent {
    control = new FormControl();
    options = [20, 30, 40, 50, 60];

    @Input() canEdit;
    @Input() value;
    @Output() valueChange = new EventEmitter();

    constructor() {
        this.control.valueChanges.subscribe(value => {
            this.value = value;
            this.valueChange.emit(this.value);
        });
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/slideCount.component.ts